import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import "../../Style/Theme/index.css";

const SittingAnimation = () => {
  const container = useRef(null);
  const doc = useRef(null);
  //let audio = new Audio('../../../public/assets/audio/success.wav');
  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: false,
      animationData: require("../../utils/lottie/paperAnimation.json"),
    });
    const docAnimation = lottie.loadAnimation({
      container: doc.current,
      renderer: "svg",
      loop: false,
      animationData: require("../../utils/lottie/docAnimation.json"),
    });
    docAnimation.addEventListener("complete", function () {
      // audio.play();
    });
  }, []);
  return (
    <div>
      <div
        className="lottieContainer animationFilter"
        ref={container}
        style={{
          width: "200px",
          height: "200px",
          position: "relative",
          zIndex: "999",
        }}
      >
        <img
          src="/assets/person.svg"
          alt="person"
          className={`person lottieBg`}
        />
        <div ref={doc} className="docAnimation" />
      </div>
    </div>
  );
};

export default SittingAnimation;
